$(function() {

  if($('.loader').length == 1) {
    let video = document.querySelector('.loader_video');
    video.addEventListener('canplaythrough', () => {
      video.play();
      video.addEventListener('ended', () => {
        $('.loader').fadeOut();  
      })
    }, false);
  }

  $('.intro_carousel').owlCarousel({
    loop:true,
    margin:0,
    nav:false,
    autoplay:true,
    autoplayTimeout:6000,
    dots:true,
    responsive:{
      0:{
        items:1
      },
      600:{
        items:1
      },
      1000:{
        items:1
      }
    }
  });

  $('.infoSlider_carousel').owlCarousel({
    loop:true,
    margin:0,
    smartSpeed: 300,
    nav:true,
    center: true,
    dots:true,
    responsive:{
      0:{
        items:1
      },
      600:{
        items:1
      },
      1000:{
        items:3
      }
    }
  });

  $('.destinationSlider_carousel').owlCarousel({
    loop:true,
    margin:50,
    nav:true,
    dots:true,
    responsive:{
      0:{
        items:1
      },
      600:{
        items:2
      },
      1000:{
        items:3
      }
    }
  });

  $('.modele_3_carousel').owlCarousel({
  loop:true,
  margin:50,
  nav:true,
  dots:false,
  responsive:{
    0:{
      items:1
    },
    600:{
      items:1
    },
    1000:{
      items:1
    }
  }
});

$('.modele_6_carousel').owlCarousel({
  loop:true,
  margin:50,
  nav:true,
  dots:false,
  responsive:{
    0:{
      items:1
    },
    600:{
      items:1
    },
    1000:{
      items:1
    }
  }
});

    $('.photo_carousel').owlCarousel({
        loop:true,
        margin:50,
        nav:true,
        lazyLoad:true,
        dots:true,
        responsive:{
            0:{
                items:1
            },
            600:{
                items:1
            },
            1000:{
                items:1
            }
        }
    });

  $('.header_mobile').on('click', () => {
    $('.header_container').toggleClass('header_container-open');
  });

  $('.banner_link').on('click', () => {
      $('.photo').toggleClass('photo-open');
  });

  $('.photo_close').on('click', () => {
      $('.photo').toggleClass('photo-open');
  });

  $('.header_language').change(function(){
      let value = $(this).val();
      if(value == 'english') {
        window.location.assign('/en/');
      }
      if(value == 'france') {
          window.location.assign('/');
      }
  });

  $('.modele_6_menuItem').on('click', (e) => {
    $('.modele_6_menuItem').removeClass('modele_6_menuItem-current')
    $('.modele_6_hotel').removeClass('modele_6_hotel-visible')
    $(e.currentTarget).addClass('modele_6_menuItem-current')
    $('.modele_6_hotel').each((i, em) => {
      if ($(em).data('hotel') == $(e.currentTarget).data('hotel')) {
        $(em).addClass('modele_6_hotel-visible')
      }
    })
  })

  // $(document).ready(function() {
  //   if(sessionStorage.getItem("videofull") != 'shown'){
  //       $(".pop-in-video").fadeIn();
  //       $(".pop-in-video").css('display', 'flex');
        
  //       sessionStorage.setItem("videofull",'shown');
  //   }
  //   $('.pop-in-video').click(function(e)
  //   
  //     $(".pop-in-video").remove();
  //   });
  // });

  $( ".lang" ).hover(
    function() {
      $(".lang ul").slideDown();
    }, function() {
      $(".lang ul").slideUp();
    }
  );

});